export default "__VITE_ASSET__CDRM7HIh__"